import { SITE_URL } from '@/features/website-cms/blog/blog-url';

/** Public URL for a category roll-up page (root slug, no /categories prefix). */
export const categoryPublicUrl = (slug: string): string => `${SITE_URL}/${slug}`;
